var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9424_38482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.972221V19.0278H25V0.972221H0ZM18.0949 10.9983L16.7717 12.2947L21.793 17.1755H3.20639L8.22766 12.2947L6.90441 10.9983L1.85163 15.9107V4.10182L12.5 14.5369L23.1477 4.10182V15.91L18.0949 10.9977V10.9983ZM3.19392 2.82385H21.8061L12.5 11.9442L3.19392 2.82385Z",
    fill: "#5F5D5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9424_38482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 18.0556,
    fill: "white",
    transform: "translate(0 0.972221)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon3);
export default __webpack_public_path__ + "static/media/email-icon-3.4e1a65a020a266b51e12cc57ef03c6b9.svg";
export { ForwardRef as ReactComponent };